import React, { useEffect } from 'react';
import usePageContent from '@/hooks/usePageContent';

const ImpressumPage = () => {
  const { t: c, loaded } = usePageContent('impressum');

  useEffect(() => {
    document.title = 'Impressum | Fahrschule Rößner GmbH';
  }, []);

  // Default content as fallback
  const defaultContent = `<h2 class="text-xl font-semibold text-slate-900 mt-8 mb-4">Angaben gemäß § 5 TMG</h2>
<p><strong>Fahrschule Rößner GmbH</strong><br/>Alt Schwanheim 29<br/>60529 Frankfurt am Main</p>
<h2 class="text-xl font-semibold text-slate-900 mt-8 mb-4">Kontakt</h2>
<p>Telefon: 069 20 32 60 59<br/>E-Mail: info@roessnerfahrschule.de<br/>Internet: roessnerfahrschule.de</p>
<h2 class="text-xl font-semibold text-slate-900 mt-8 mb-4">Geschäftsführer</h2>
<p>Tugrul Baldik</p>
<h2 class="text-xl font-semibold text-slate-900 mt-8 mb-4">Registereintrag</h2>
<p>Amtsgericht: Frankfurt am Main<br/>HRB: 130004</p>
<h2 class="text-xl font-semibold text-slate-900 mt-8 mb-4">Umsatzsteuer-ID</h2>
<p>Umsatzsteuer-Identifikationsnummer gemäß §27a Umsatzsteuergesetz:<br/>DE359815479</p>
<h2 class="text-xl font-semibold text-slate-900 mt-8 mb-4">Inhaltlich Verantwortlicher gemäß § 55 Abs. 2 RStV</h2>
<p>Tugrul Baldik<br/>Alt Schwanheim 29<br/>60529 Frankfurt am Main</p>
<h2 class="text-xl font-semibold text-slate-900 mt-8 mb-4">Haftungsausschluss</h2>
<h3 class="text-lg font-medium text-slate-900 mt-6 mb-3">Haftung für Inhalte</h3>
<p>Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.</p>
<h3 class="text-lg font-medium text-slate-900 mt-6 mb-3">Haftung für Links</h3>
<p>Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben.</p>
<h3 class="text-lg font-medium text-slate-900 mt-6 mb-3">Urheberrecht</h3>
<p>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht.</p>`;

  const content = c('content', defaultContent);

  return (
    <div className="pt-20" data-testid="impressum-page">
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-slate-900 mb-8">Impressum</h1>
          <div 
            className="prose prose-lg max-w-none text-slate-700"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </div>
      </section>
    </div>
  );
};

export default ImpressumPage;
